module.exports = __webpack_public_path__ + "media/images/sub-landing-dark-4f4b96239a29705097d1fc655f007811.png";